"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showSuggestedProviders = exports.showNoAvailabilityErrorBanner = exports.showLoader = exports.shouldShowLoaderMessage = void 0;
const States_1 = require("../../lib/constants/States");
/**
 * Method to check if the loader message should be shown
 *
 * @param {xstate.StateNode} state
 * @returns {boolean}
 */
function shouldShowLoaderMessage(state) {
    return state.matches(`${States_1.apptQuestions}.${States_1.conditionalGxQuestions}.${States_1.pending}`);
}
exports.shouldShowLoaderMessage = shouldShowLoaderMessage;
/**
 * Method to check if the loader should be shown
 *
 * @param {xstate.StateNode} state
 * @returns {boolean}
 */
function showLoader(state) {
    return (state.matches(`${States_1.apptQuestions}.${States_1.conditionalGxQuestions}.${States_1.pending}`) ||
        state.matches(`${States_1.apptQuestions}.${States_1.apptPurpose}.${States_1.noAvailability}.${States_1.fetchingAltProviders}`) ||
        state.matches(`${States_1.apptQuestions}.${States_1.apptPatientRel}.${States_1.noAvailability}.${States_1.fetchingAltProviders}`) ||
        state.matches(`${States_1.apptQuestions}.${States_1.apptPurpose}.${States_1.noResults}.${States_1.fetchingAltProviders}`));
}
exports.showLoader = showLoader;
/**
 * Method to check if the no availability error banner should be shown
 *
 * @param {xstate.StateNode} state
 * @returns {boolean}
 */
function showNoAvailabilityErrorBanner(state) {
    return ((state.matches(`${States_1.apptQuestions}.${States_1.apptPurpose}.${States_1.noAvailability}`) ||
        state.matches(`${States_1.apptQuestions}.${States_1.apptPatientRel}.${States_1.noAvailability}`) ||
        state.matches(`${States_1.apptQuestions}.${States_1.apptPurpose}.${States_1.noResults}`)) &&
        // conditions to hide error banner while it is fetching suggested providers
        !state.matches(`${States_1.apptQuestions}.${States_1.apptPurpose}.${States_1.noAvailability}.${States_1.fetchingAltProviders}`) &&
        !state.matches(`${States_1.apptQuestions}.${States_1.apptPatientRel}.${States_1.noAvailability}.${States_1.fetchingAltProviders}`) &&
        !state.matches(`${States_1.apptQuestions}.${States_1.apptPurpose}.${States_1.noResults}.${States_1.fetchingAltProviders}`));
}
exports.showNoAvailabilityErrorBanner = showNoAvailabilityErrorBanner;
/**
 * Method to check if the suggested providers should be shown
 *
 * @param {xstate.StateNode} state
 * @returns {boolean}
 */
function showSuggestedProviders(state) {
    return (state.matches(`${States_1.apptQuestions}.${States_1.apptPurpose}.${States_1.noAvailability}.${States_1.suggestedProviders}`) ||
        state.matches(`${States_1.apptQuestions}.${States_1.apptPatientRel}.${States_1.noAvailability}.${States_1.suggestedProviders}`) ||
        state.matches(`${States_1.apptQuestions}.${States_1.apptPurpose}.${States_1.noResults}.${States_1.suggestedProviders}`));
}
exports.showSuggestedProviders = showSuggestedProviders;
//# sourceMappingURL=utils.apptInfo.js.map